import React from 'react'
import { Button } from '@fs/zion-ui'
import { useHistory } from '@fs/zion-router'
import { Arrow } from '@fs/zion-icon'
import { css } from '@emotion/core'

const detailBarStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding-top: 16px;
`
const leftContentStyle = css`
  align-self: center;
  & > button {
    color: white !important;
  }
`

const TopDetailBar = ({ backText, children }) => {
  const history = useHistory()
  return (
    <>
      <div css={detailBarStyle}>
        <div css={leftContentStyle}>
          <Button
            onClick={() => {
              history.goBack()
            }}
            Icon={Arrow}
            iconDirection="left"
            data-testid="back-button"
          >
            {backText}
          </Button>
        </div>
        <div>{children}</div>
      </div>
    </>
  )
}

export default TopDetailBar
